import { mixins } from 'vue-class-component';
import { Component, Prop, Inject, Emit, Ref } from 'vue-property-decorator';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import AlertService from '@/shared/alert/alert.service';
import { FiltroMovimientoBeca } from '@/shared/model/filtro-movimiento-beca.model';
import MovimientoAcademicoService from '@/entities/seguimiento/academico/movimiento-academico.service';
import * as dateUtils from '@/shared/date/date-utils';
import { IMovimientoAcademico } from '@/shared/model/seguimiento/movimiento-academico.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import { Area } from '@/shared/model/enumerations/area';
import { EstadoMovimientoBeca } from '@/shared/model/enumerations/estado-movimiento-beca.model';
import { Beca } from '@/shared/model/seguimiento/beca.model';
import BecaService from '@/entities/seguimiento/beca.service';
import { DmsApi, EtapaEnum, Archivo } from '@conacyt/dms-client';
import JhiDataUtils from '@/shared/data/data-utils.service';
import { required } from 'vuelidate/lib/validators';
import PeriodosAnualesExtrangerasService from '@/entities/seguimiento/extranjeras/periodos-lectivos/periodos-anuales-extrangeras.service';

@Component({
  computed: {
    userInfo: {
      get() {
        return this.$store.getters.userInfo;
      },
    },
    username: {
      get() {
        return this.$store.getters.account?.login ?? '';
      },
    },
  },
})
export default class PeriodosLectivosComponent extends mixins(JhiDataUtils) {
  @Inject('personalBecaService') public personalBecaService: () => PersonalBecaService;
  @Inject('alertService') public alertService: () => AlertService;
  @Inject('movimientoAcademicoService') public movimientoAcademicoService: () => MovimientoAcademicoService;
  @Inject('becaService') public becaService: () => BecaService;
  @Inject('dmsApi') public dmsApi: () => DmsApi;
  @Inject('periodosAnualesExtrangerasService') public periodosAnualesExtrangerasService: () => PeriodosAnualesExtrangerasService;

  public readonly userInfo!: any;

  public readonly username!: any;

  @Prop({ required: true })
  public idBeca: string;

  @Prop({ required: false })
  public visible: boolean;

  public periodosList = [];
  public totalItems = 0;
  public componenteVisible = false;
  public permisoAgregarMovimiento = true;
  public totalRows = 0;
  public filtro = new FiltroMovimientoBeca();
  public beca = new Beca();
  public propOrder = 'id';
  public reverse = false;
  private rol: RolAutoridad;
  public estadoCapturado = EstadoMovimientoBeca.CAPTURADO;
  public estadoRevisado = EstadoMovimientoBeca.REVISADO;
  public estadoPendiente = EstadoMovimientoBeca.PENDIENTE;
  public permiteConsulta = false;
  public permiteRevisar = false;
  public fechaActual = new Date();
  private accesoPermisos = {
    permiteConsulta: [
      RolAutoridad.DIRECTOR,
      RolAutoridad.SUBDIRECTOR,
      RolAutoridad.JEFE_DEPARTAMENTO,
      RolAutoridad.OPERADOR,
      RolAutoridad.COORDINADOR_PROGRAMA,
      RolAutoridad.BECARIO,
    ],
    permiteRevisar: [
      RolAutoridad.COORDINADOR_PROGRAMA,
      RolAutoridad.DIRECTOR,
      RolAutoridad.SUBDIRECTOR,
      RolAutoridad.JEFE_DEPARTAMENTO,
      RolAutoridad.OPERADOR,
    ],
  };

  // Manejo de documentos
  private ETAPA: EtapaEnum = 'REGISTRO';
  private CARPETA = 'DADC';
  public documentoModel: any = {};
  public currentFile: any = null;
  public currentContent: any = null;
  public isSaving = false;
  public solicitudId = '';

  public isLoading = false;
  public periodosAnualesData: any = null;

  public isCoordinador = false;
  public isAdmvo = false;
  public isBecario = false;
  public decision: boolean | null = null;
  public comentario = '';

  public readonly fields = [
    {
      key: 'periodoEvaluacion.anio',
      label: this.$t('apeironGwApp.periodoEvaluacion.grid.anio'),
      class: 'text-left font-weight-bold',
      thStyle: { width: '7rem' },
    },
    {
      key: 'periodoEvaluacion.numero',
      label: this.$t('apeironGwApp.periodoEvaluacion.grid.numero'),
      class: 'text-left',
      thStyle: { width: '9rem' },
    },
    {
      key: 'periodoEvaluacion.fechaInicio',
      label: this.$t('apeironGwApp.periodoEvaluacion.grid.fechaInicio'),
      class: 'text-left',
      thStyle: { width: '9rem' },
      formatter: dateUtils.defaultFormat,
    },
    {
      key: 'periodoEvaluacion.fechaFin',
      label: this.$t('apeironGwApp.periodoEvaluacion.grid.fechaFin'),
      class: 'text-left',
      thStyle: { width: '9rem' },
      formatter: dateUtils.defaultFormat,
    },
    {
      key: 'estadoCaratula',
      label: this.$t('apeironGwApp.periodoEvaluacion.label.estado'),
      class: 'text-left',
      thStyle: { width: '14rem' },
    },
    {
      key: 'estadoDocumento',
      label: this.$t('apeironGwApp.comprobanteInscripcion.grid.estatusDocumento'),
      class: 'text-left',
      thStyle: { width: '14rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.periodoEvaluacion.grid.acciones'),
    },
  ];

  public mounted(): void {
    this.componenteVisible = this.visible;

    this.retrivePersonalBeca();

    this.becaService()
      .find(this.idBeca)
      .then(beca => {
        this.beca = beca;
        this.solicitudId = beca.solicitud.id;
      })
      .catch(err => {
        this.alertService().showHttpError(this, err.response);
      });

    this.periodosAnualesExtrangerasService()
      .findByIdBeca(this.idBeca)
      .then(response => {
        this.periodosAnualesData = response;

        // Validar que exista el formatoIncorporacion y tenga elementos
        if (response.formatoIncorporacion && response.formatoIncorporacion.length > 0) {
          const ultimoDoc = response.formatoIncorporacion[response.formatoIncorporacion.length - 1];
          this.comentario = ultimoDoc.comentarios;
          // Asignar el documentoModel con los datos del primer documento
          this.documentoModel = {
            uri: ultimoDoc.uri,
            nombre: ultimoDoc.nombre || 'Documento sin nombre',
          };
        } else {
          this.documentoModel = {};
        }
        const esMismaFecha = (fecha1: Date, fecha2: Date): boolean => {
          return (
            fecha1.getFullYear() === fecha2.getFullYear() &&
            fecha1.getMonth() === fecha2.getMonth() &&
            fecha1.getDate() === fecha2.getDate()
          );
        };

        const hoy = new Date();

        this.periodosList = response.periodos.map(periodo => {
          const fechaInicio = new Date(periodo.fechaInicioPeriodo);
          const fechaFin = new Date(periodo.fechaFinPeriodo);

          let estado = '';
          let variant = '';
          let permiteConsulta = false;
          let permiteRevisar = false;

          if (hoy >= fechaInicio && hoy <= fechaFin) {
            // Vigente
            estado = this.$t('Vigente').toString();
            variant = 'success';
            permiteConsulta = true;
            permiteRevisar = false;
          } else if (hoy < fechaInicio) {
            // Pendiente
            estado = this.$t('Pendiente').toString();
            variant = 'warning';
            permiteConsulta = false;
            permiteRevisar = false;
          } else {
            // No Vigente
            estado = this.$t('No Vigente').toString();
            variant = 'secondary';
            permiteConsulta = true;
            permiteRevisar = false;
          }

          let estadoDocumento = 'Sin Documento';

          if (periodo.comprobanteInscripcionAnual && periodo.comprobanteInscripcionAnual.length > 0) {
            const comprobantes = periodo.comprobanteInscripcionAnual;
            const ultimo = comprobantes[comprobantes.length - 1];

            if (ultimo && ultimo.status) {
              estadoDocumento = ultimo.status;
            }
          }

          return {
            id: periodo.numeroPeriodo,
            periodoEvaluacion: {
              anio: periodo.fechaInicioPeriodo,
              numero: periodo.numeroPeriodo,
              fechaInicio: periodo.fechaInicioPeriodo,
              fechaFin: periodo.fechaFinPeriodo,
            },
            estadoCaratula: estado,
            estadoDocumento: estadoDocumento,
            variant: variant,
            permiteConsulta: permiteConsulta,
            permiteRevisar: permiteRevisar,
            comprobanteInscripcionAnual: periodo.comprobanteInscripcionAnual || [],
          };
        });

        this.totalItems = this.periodosList.length;
      })
      .catch(error => {
        console.error('Error en findByIdBeca:', error);
      });
  }

  public irADetalleMovimientoAcademico(item: IMovimientoAcademico, esRevision: boolean) {
    this.$router.push({
      name: 'DetalleDocumentos',
      params: { idSolicitud: this.solicitudId, idBeca: this.idBeca, idPeriodo: item.id, esRevision: esRevision.toString() },
    });
  }

  public isUpdating() {
    return this.isSaving;
  }

  /**
   * Consulta si es coordinador de programa.
   */
  private retrivePersonalBeca(): void {
    this.personalBecaService()
      .find(true, Area.BECAS_EXTRANJERO)
      .then(res => {
        // Reiniciar flags
        this.isAdmvo = false;
        this.isBecario = false;

        const rol = res.rol;

        if (rol === RolAutoridad.OPERADOR || rol === RolAutoridad.SUBDIRECTOR || rol === RolAutoridad.DIRECTOR) {
          this.isAdmvo = true;
        } else if (rol === RolAutoridad.BECARIO) {
          this.isBecario = true;
        }
      })
      .catch(err => {
        this.alertService().showHttpError(this, err.response);
      });
  }
}
